/* Copyright (c) 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  GetEventViewDocument,
  useRerunEventActionMutation,
} from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useRerunEventAction({ onSuccess }: Props) {
  const [rerunEventActionMutation, { loading }] = useRerunEventActionMutation({
    onCompleted: (data) => {
      if (data.rerunEventAction) {
        onSuccess();
        showSuccess(generateActionSuccessText("Action")()("rerun")());
      }
    },
    onError: (error) => {
      showError(error.message);
    },
    refetchQueries: [GetEventViewDocument],
    awaitRefetchQueries: true,
  });

  async function rerunEventAction(
    eventId: string,
    attemptEventActionId: string
  ) {
    await rerunEventActionMutation({
      variables: {
        input: {
          eventId,
          eventActionId: attemptEventActionId,
        },
      },
    });
  }

  return { rerunEventAction, loading } as const;
}
